import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent {
  title = 'HPDM';

  constructor(
    private translate: TranslateService
  ) {
    const userLang = navigator.language || window.navigator.language; // Ej. "zh-CN", "es", "en-US"
    const supportedLangs = ['en', 'es', 'fr', 'de', 'zh-CN']; // Los idiomas que tienes disponibles

    let lang = userLang;
    console.log("USER LANG", lang);

    // Normaliza lang a formato exacto si solo viene "zh" o "en-US"
    if (lang.startsWith('zh')) {
      lang = 'zh-CN';
    } else if (lang.startsWith('es')) {
      lang = 'es';
    } else if (lang.startsWith('fr')) {
      lang = 'fr';
    } else if (lang.startsWith('de')) {
      lang = 'de';
    } else {
      lang = 'en'; // idioma por defecto
    }

    // Asegúrate de usar solo idiomas soportados
    if (!supportedLangs.includes(lang)) {
      lang = 'en';
    }

    this.translate.setDefaultLang(lang);
    this.translate.use(lang);

  }
}
